<template>
<el-date-picker
  @change="getTimeRange"
      :editable="false"
      v-model="date"
      type="date"
      placeholder="选择日"
      :picker-options="pickerOptions"
      :clearable="false"
      >
</el-date-picker>
</template>

<script>
const moment = require('moment')
export default {
  name: 'yearTimeSelector',
  data () {
    return {
      date: new Date(),
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      }
    }
  },
  methods: {
    getTimeRange () {
      // const hoursInDay = moment(this.date).add(1, 'days')
      this.$emit('input', [this.date.getTime(), moment(this.date).endOf('day').add(1, 'ms').valueOf()])
    }
  },
  computed: {
  }
}
</script>

<style lang="scss" scoped>
.el-date-editor {
  width: 140px;
}
</style>
